import React from 'react';
import { Nullable } from '../Shared/Types';
import styles from './ReadOnlyField.module.scss';
import classNames from 'classnames';

type ReadOnlyFieldProps = {
    label?: Nullable<React.ReactNode>; // Only null will hide the label completely
    hideHelperText?: boolean;
    mode?: 'heading' | 'field';
};

export const ReadOnlyField: React.FC<ReadOnlyFieldProps> = props => {
    const nbsp = '\u00a0';
    const children = props.children === '' || React.Children.count(props.children) === 0 ? nbsp : props.children;
    const mode = props.mode ?? 'field';

    const fieldClasses = classNames(styles.readOnlyField, {
        [styles.fieldMode]: mode === 'field',
        [styles.noLabel]: props.label === null,
        [styles.noHelperText]: props.hideHelperText
    });

    const valueClasses = classNames(styles.value, {
        [styles.fieldModeValue]: mode === 'field'
    });

    return (
        <div className={fieldClasses}>
            {props.label !== null && <div className={styles.label}>{props.label || nbsp}</div>}
            <div className={valueClasses}>{children}</div>
        </div>
    );
};
